(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    

  document.addEventListener("DOMContentLoaded", function () {
    // Handle the header resizing on scroll
    const header = document.getElementById('topHeader');
    const bodyElem = document.body;

    window.addEventListener('scroll', function () {
      if (window.scrollY > 150) {
        header.classList.add('shorten');
        bodyElem.classList.add('header-shorten');
      } else {
        header.classList.remove('shorten');
        bodyElem.classList.remove('header-shorten');
      }
    });

    // Handle the menu button
    const menuButtonWrap = document.querySelector('.mobile-menu');
    const menuButton = document.getElementById('menuBtn');
    const menuBar = document.querySelector('.menu-bar');
    const topHeader = document.getElementById('topHeader');

    // Listen for a click on the menu button #menuBtn
    menuButton.addEventListener('click', function () {
      // Toggle the 'active' class on the menu button
      menuButtonWrap.classList.toggle('active');

      // Toggle the 'open' class on the menu
      menuBar.classList.toggle('open');

      // Toggle the 'open' class on the top header
      topHeader.classList.toggle('menu-open');
    });
  });

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      // If this is scrolled beyond a certain point, we want to add a class to the header
      let headElement = document.getElementById('topHeader');
      if (scrollTop > 320) {
        console.log("Scroll triggered");
          headElement.addClass('scrolled');
      } else {
        headElement.removeClass('scrolled');
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["parallax-image"] && !Shopify.designMode) return;
  try {
    

document.addEventListener('DOMContentLoaded', function() {
  const parallaxImageWrapper = document.getElementById('paraImg');
  const mvImg = parallaxImageWrapper.querySelector('.img-container');
  if (parallaxImageWrapper) {
    window.addEventListener('scroll', function() {
      const scrollPosition = window.scrollY;
      
      // Get the top position of the parallax image wrapper
      const parallaxImageTop = parallaxImageWrapper.getBoundingClientRect().top;
      
      // How high is the viewport? 
      const viewportHeight = window.innerHeight;

      // How high is the parallax image wrapper?
      const parallaxImageHeight = parallaxImageWrapper.offsetHeight;

      // How high is the parallax image?
      const parallaxImageHeightInner = mvImg.offsetHeight;

      // If we are above the bottom of the screen then start parallaxing 
      if (parallaxImageTop > viewportHeight || parallaxImageTop < (parallaxImageHeight * -1)) {
        return;
      }

      // Calculate the desired position based on the scroll position
      let scrollDistance = (parallaxImageTop + parallaxImageHeight) / (viewportHeight + parallaxImageHeight);
      let topPosn = (parallaxImageHeightInner - parallaxImageHeight) * scrollDistance;

      mvImg.style.top = `-${topPosn}px`;
    });
  }
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  let activeSlide = "";
  let nxtSlide = "";
  let blockIds = [];
  let currentIndex = 0;
  let autoSlideInterval;
  
  const testimonials = document.querySelectorAll('.testimonial');
  const prevButton = document.getElementById('testPrevBtn');
  const nextButton = document.getElementById('testNextBtn');

  // Build array of block IDs and initialize currentIndex
  testimonials.forEach((testimonial, index) => {
    blockIds.push(testimonial.getAttribute('data-block'));
    if (testimonial.classList.contains('active')) {
      currentIndex = index;
    }
  });

  if (blockIds.length > 0) {
    activeSlide = blockIds[currentIndex];
    if (blockIds[currentIndex + 1]) {
      nxtSlide = blockIds[currentIndex + 1];
    } else {
      nxtSlide = blockIds[0]; // Loop back to first
    }
    setActiveSlide(activeSlide, nxtSlide);
    
    // Only start auto-slide if there are multiple testimonials
    if (blockIds.length > 1) {
      startAutoSlide();
    }
  }

  // Previous button event listener
  if (prevButton) {
    prevButton.addEventListener('click', (e) => {
      e.preventDefault();
      stopAutoSlide();
      goToPrevSlide();
      if (blockIds.length > 1) {
        startAutoSlide();
      }
    });
  }

  // Next button event listener
  if (nextButton) {
    nextButton.addEventListener('click', (e) => {
      e.preventDefault();
      stopAutoSlide();
      goToNextSlide();
      if (blockIds.length > 1) {
        startAutoSlide();
      }
    });
  }

  // Functions
  function goToNextSlide() {
    currentIndex = (currentIndex + 1) % blockIds.length;
    updateSlide();
  }

  function goToPrevSlide() {
    currentIndex = (currentIndex - 1 + blockIds.length) % blockIds.length;
    updateSlide();
  }

  function updateSlide() {
    activeSlide = blockIds[currentIndex];
    nxtSlide = blockIds[(currentIndex + 1) % blockIds.length];
    setActiveSlide(activeSlide, nxtSlide);
  }

  function startAutoSlide() {
    if (blockIds.length <= 1) return;
    
    autoSlideInterval = setInterval(() => {
      goToNextSlide();
    }, 12000);
  }

  function stopAutoSlide() {
    if (autoSlideInterval) {
      clearInterval(autoSlideInterval);
      autoSlideInterval = null;
    }
  }

  function setActiveSlide(activeId, nxtId) {
    // Remove all active and next classes first
    testimonials.forEach(testimonial => {
      testimonial.classList.remove('active', 'next');
    });
    
    // Set the active testimonial
    const newActiveTestimonial = document.getElementById(activeId);
    if (newActiveTestimonial) {
      newActiveTestimonial.classList.add('active');
    }
    
    // Set the next testimonial
    const nextTestimonial = document.getElementById(nxtId);
    if (nextTestimonial) {
      nextTestimonial.classList.add('next');
    }
  }
});

  } catch(e) { console.error(e); }
})();
})();
